import {
  Space,
  Dropdown,
  message
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  EditOutlined,
  MenuOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import MainContractModal from "./component/MainContractModal";
import UploadTenantModal from "./component/UploadTenantModal";
import CustomModalTable from "./component/CustomModalTable";
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
    entityStr: undefined,
    propCount: undefined,
    monthlyPayment: undefined,
    achAccount: undefined,
    currentLoan: undefined,
    originalLoan: undefined,
    lender: undefined,
    loanDate: undefined,
    loanEndDate: undefined,
    rateType: undefined,
    interestRate: undefined,
    swapEndDate: undefined,
    termAmortPeriod: undefined,
    variableIndex: undefined,
    marginRate: undefined,
    loanType: undefined,
    recourse: undefined,
  }
  const [tableHead, setTableHead] = useState(initTableHead);
  const [loanTypeList, setLoanTypeList] = useState([]);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record, index) => (
        (commonFn.btnAuthorityFlag("Edit") || commonFn.btnAuthorityFlag("prop")) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag("Edit") && {
                key: "edit",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit</div>,
              },
              {
                key: "viewLoan",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Enter Payment</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }} 
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>
        )) || null
    },
    {
      title: "Lender",
      dataIndex: "vendorName",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),

    },
    {
      title: "Loan Number",
      dataIndex: "loanNumber",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "loanNumber"),
    }, 
    {
      title: '# of Properties',
      dataIndex: "propCount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: 'Loan Date',
      dataIndex: "loanDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      onChange: (e) => tableFilterFn(e, 'loanDate', 'DatePickerFormat'),
    },
    {
      title: 'Maturity Date',
      dataIndex: "loanEndDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      onChange: (e) => tableFilterFn(e, 'loanEndDate', 'DatePickerFormat'),
    },
    {
      title: 'Rate Type',
      dataIndex: "rateType",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Fix", value: 1 },
        { label: "Variable", value: 2 },
      ],
      onChange: e => tableFilterFn(e, 'rateType', 'Select'),
      render: (text) => {
        const rateTypeMatch = {
          1: "Fix",
          2: "Variable",
        }
        return rateTypeMatch[text] || ""
      },
    },
    {
      title: 'Interest Rate',
      dataIndex: "interestRate",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      isPercent: true,
      onChange: e => tableFilterFn(e, 'interestRate')
    },
    {
      title: 'Swap/Fix End Date',
      dataIndex: "swapEndDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      width: 160,
      onChange: (e) => tableFilterFn(e, 'swapEndDate', 'DatePickerFormat'),
    },
    {
      title: 'Loan Type',
      dataIndex: "loanType",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: loanTypeList,
      onChange: e => tableFilterFn(e, 'loanType', 'Select'),
    },
    {
      title: "Loan Balance",
      dataIndex: "loanBalance",
      titleType: "",
      isAmountFlag: true,
    },
    {
      title: 'Entity',
      dataIndex: "entityStrList",
      titleType: '',
      isSorter: true,
      width: 120,
      sortterMultiple: 3,
      render: (text) => {
        return (
          <>
            {(text || [])?.map(item => (
               <div>
                { item }
              </div>
            ))}
          </>
        )
      }
    },
    {
      title: 'Payoff Date',
      dataIndex: "paidOffDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      width: 160,
      onChange: (e) => tableFilterFn(e, 'paidOffDate', 'DatePickerFormat'),
    },
    // ==========



    // {
    //   title: 'Monthly',
    //   dataIndex: "monthlyPayment",
    //   titleType: '',
    //   isSorter: true,
    //   sortterMultiple: 3,
    // },
    // {
    //   title: 'ACH Account',
    //   dataIndex: "achAccount",
    //   titleType: 'Input',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'achAccount')
    // },
    // {
    //   title: "Current Loan",
    //   dataIndex: "currentLoan",
    //   titleType: "Input",
    //   width: 100,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, "currentLoan"),
    // },
    // {
    //   title: "Original Loan",
    //   dataIndex: "originalLoan",
    //   titleType: "Input",
    //   width: 100,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, "originalLoan"),
    // },
    // {
    //   title: 'Term/Amort',
    //   dataIndex: "termAmortPeriod",
    //   titleType: 'Input',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'termAmortPeriod'),
    // },
    // {
    //   title: 'Variable Index',
    //   dataIndex: "variableIndex",
    //   titleType: 'Input',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'variableIndex')
    // },
    // {
    //   title: 'Margin',
    //   dataIndex: "marginRate",
    //   titleType: 'Input',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'marginRate')
    // },
    // {
    //   title: 'Recourse',
    //   dataIndex: "recourse",
    //   titleType: 'Select',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   selectOptions: [
    //     { label: "Yes", value: 1 },
    //     { label: "No", value: 2 },
    //   ],
    //   render: (text) => {
    //     const recourseMatch = {
    //       1: "Yes",
    //       2: "No",
    //     }
    //     return recourseMatch[text] || ""
    //   },
    //   onChange: e => tableFilterFn(e, 'recourse', 'Select'),
    // },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [month6Columns, setMonth6Columns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.post(api.getMortgageRollingList, params);
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setSelectedList([])
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  // 新增修改
  const MainContractRef = useRef(null);
  
  const newFn = () => {
    MainContractRef.current.openModal({
      type: 'add',
      modalName: 'New Mortgage',
    })
  }

  const handleMenuClick = async (item, record) => {
    const { key } = item
    if(['edit'].includes(key)){
      MainContractRef.current.openModal({
        rollId: record.id,
        type: 'edit',
        modalName: 'Edit Mortgage',
      })
    } else if (['viewLoan'].includes(key)){
      const route = `/AccountPayable/ViewLoan?rollId=${record.id}`
      const url = `${window.location.origin}#${route}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }
  }

  const [selectedList, setSelectedList] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const customModalRef = useRef(null);

  const deleteFn = async () => {
    setDeleteLoading(true)
    const response = await http.get(api.delMortgageRolling, {
      params: {
        ids: String(selectedList.map(item => item.id))
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setDeleteLoading(false)
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 100,
      total: 0,
    })
    setDeleteLoading(false)
    setSelectedList([])
    setTableList([])
    setTableHead(initTableHead);
    setColumns([...initColumns, ...month6Columns]);
  }

  const submitInitFn = () => {
    initColunmsFn()
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  }

  const getLoanTypeListFn = async() => {
    const response = await http.get(api.getMortgageLoanType);
    if (response.code === "1") {
      setLoanTypeList(response.data);
    }
  }

  const customModalTableRef = useRef(null);

  const month6ColumnsFn = async () => {
    const response = await http.get(api.mortgageTitle);
    if(response?.code === "1"){
      const month6Columns = (response?.data || [])?.map((month) => ({
        title: month,
        dataIndex: month,
        key: month,
        width: 100,
        onCell: () => ({className: 'cellAmount'}),
        render: (text, record) => {
          const result = record?.map?.[month] || null;
          return result?.id ? (<span
            onClick={() => customModalTableRef.current.openModal(result?.id)}
            style={{
              color: result?.colorStr || "#1890ff",
              // textDecoration: "underline dashed",
              cursor: "pointer",
            }}
          >
            {commonFn.amountToDollarFn(result?.repayment)}
          </span>) : null
        },
      }));
      setMonth6Columns(month6Columns)
    }
  };

  useEffect(() => {
    getLoanTypeListFn()
    month6ColumnsFn()
  }, [])

  useEffect(() => {
    if(loanTypeList?.length || month6Columns?.length){
      setColumns([...initColumns, ...month6Columns]);
    }
  }, [loanTypeList, month6Columns])

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])

  const UploadTenantRef = useRef(null);

  const uploadTenantFn = () => {
    UploadTenantRef.current.openModal({
      downloadList: [
        {
          iconKey: 'docIcon',
          text: 'Click Here for File Format instruction',
          desc: 'Upload allows users to add single and multiple For the CSV file formatting instructions please click link below',
          downloadState: {
            url: api.mortgageDownload,
            params: {type: 1},
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            suffix: 'docx',
            name: `Mortgage-Upload-Instruction`
          }
        },
        {
          iconKey: 'csvIcon',
          text: 'Click Here for sample File',
          desc: 'To Use Upload,Please Drag & Drop a csv File',
          downloadState: {
            url: api.mortgageDownload,
            params: {type: 2},
            type: 'text/csv;charset=utf-8;',
            suffix: 'csv',
            name: `Mortgage-Upload-Sample`
          }
        },
      ],
      uploadFileState: {
        url: api.importMortgageRollingExcel
      }
    })
  }

  const uploadAllFn = () => {
    UploadTenantRef.current.openModal({
      downloadList: [
        {
          iconKey: 'docIcon',
          text: 'Click Here for File Format instruction',
          desc: 'Upload allows users to add single and multiple For the CSV file formatting instructions please click link below',
          downloadState: {
            url: api.mortgageDownload,
            params: {type: 5},
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            suffix: 'docx',
            name: `Mortgage-Upload-Instruction`
          }
        },
        {
          iconKey: 'csvIcon',
          text: 'Click Here for sample File',
          desc: 'To Use Upload,Please Drag & Drop a csv File',
          downloadState: {
            url: api.mortgageDownload,
            params: {type: 6},
            type: 'text/csv;charset=utf-8;',
            suffix: 'csv',
            name: `Mortgage-Upload-Sample`
          }
        },
      ],
      uploadFileState: {
        url: api.importAllExcel
      }
    })
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("New") && (
            <Space size="large">
                {commonFn.btnDocFn({ btnFn: newFn },{
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}
          {(commonFn.btnAuthorityFlag("Delete") && (
            <Space size="large">
                {commonFn.btnDocFn({ name: 'Delete', btnFn: () => {
                  if(!selectedList?.length){
                    message.warning("Please select at least one item.");
                  } else {
                    customModalRef.current.openModalFn()
                  }
                },loading: deleteLoading},{
                  iconKey: 'deleteIcon',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}
          {(commonFn.btnAuthorityFlag("UploadCSV") && (
            <Space size="large">
                {commonFn.btnDocFn({ name: 'Upload', btnFn: uploadTenantFn },{
                  iconKey: 'uploadIcon',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
           )) || null}
           {(commonFn.btnAuthorityFlag("UploadAll") && (
            <Space size="large">
                {commonFn.btnDocFn({ name: 'Upload Loan And Prop Info', btnFn: uploadAllFn },{
                  iconKey: 'uploadIcon',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
           )) || null}
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map(item => item.id),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="360px"
      />

      <MainContractModal
        ref={MainContractRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          content: 'Are you sure to delete selected data?',
          onOkFn: deleteFn,
        }}
      />

      <UploadTenantModal
        ref={UploadTenantRef}
        submitInitFn={submitInitFn}
      />

      <CustomModalTable
        ref={customModalTableRef}
      />
    
    </div>
  );
});
export default MainTable;